import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { lazyLoadingData } from '../../functions';
import {
  Box3,
  BoxBufferGeometry,
  Color,
  Euler,
  Group,
  InstancedMesh,
  LinearEncoding,
  Matrix4,
  Mesh,
  MeshBasicMaterial,
  MeshStandardMaterial,
  Quaternion,
  Raycaster,
  TextureLoader,
  default as THREE,
  Vector3,
  LinearFilter,
  LinearMipmapLinearFilter,
  RepeatWrapping,
  MeshPhongMaterial,
  EquirectangularReflectionMapping,
} from 'three';
import { globalTextures, settingsData, threeJsVariables } from '../../settings';
import gsap from "gsap";
import { basic_tile } from '../threejs/environment';

const axios = require('axios').default;

let platePoints;
// ../../../resources/sceneObjects/platePoints

export const sceneObjectsGroup = new Group();
sceneObjectsGroup.name = 'Scene objects';

export function addSceneObjects (manager,textureLoader,gltfLoader) {
  const { active, models } = config.resources.sceneObjects;

  if (!active) return;

  const {cdnRepository,projectFolder} = config;
  const url = `${cdnRepository}/${projectFolder}/resources/sceneObjects/models/`;
  const textureUrl = `${config.cdnRepository}/${config.projectFolder}/resources/textures/building/`;
  const fbxLoader = new FBXLoader(manager);


  models.forEach(modelObject => {

    const extension = modelObject.path.split('.')[1];

    switch (extension) {

      case 'glb':

        gltfLoader.load(url + modelObject.path, (gltf) =>{
          let meshMaterial;

          if (modelObject.material){

            if (modelObject.material.specularMap){
              meshMaterial = new MeshPhongMaterial();
            } else {
              meshMaterial = new MeshStandardMaterial();
            }

            const materials = modelObject.material;

            for (let key in materials) {

              const value = materials[key];

              if ( value instanceof Object){
                let texture;

                const fullUrl = textureUrl + value.path;

                if (globalTextures.hasOwnProperty(fullUrl)){
                  texture = globalTextures[fullUrl];
                } else {
                  texture = textureLoader.load(fullUrl);
                  globalTextures[fullUrl] = texture;
                }

                texture.name = key;

                if (key==='envMap'){
                  texture.mapping = EquirectangularReflectionMapping;
                }

                Object.entries(value).forEach(([key,value])=>{
                  if (key !== 'path'){
                    texture[key]  = value;
                    texture.encoding = LinearEncoding;
                    texture.wrapS = RepeatWrapping;
                    texture.wrapT = RepeatWrapping;
                    texture.offset.set(0,0);
                    texture.repeat.set(1,1);
                  }
                });

                meshMaterial[key] = texture;
              }else{
                meshMaterial[key] = value;
              }

            }

          }

          const objectGroup = new Group();

          gltf.scene.traverse(el => {
            if (el.material) {
              el.material = meshMaterial.clone();

              const mesh = new Mesh(el.geometry,el.material);
              mesh.castShadow = true;
              mesh.receiveShadow = true;
              mesh.position.copy(el.position);
              mesh.scale.copy(el.scale);
              mesh.rotation.copy(el.rotation);

              objectGroup.add(mesh);
            }
          });

          objectGroup.position.set(modelObject.position.x,modelObject.position.y,modelObject.position.z);
          objectGroup.rotation.set(modelObject.rotation.x,modelObject.rotation.y,modelObject.rotation.z);
          objectGroup.scale.set(modelObject.scale.x,modelObject.scale.y,modelObject.scale.z);
          objectGroup.name = modelObject.name;

          sceneObjectsGroup.add(objectGroup);
        });


        break;

      case 'fbx':

        fbxLoader.load(url + modelObject.path,(loadedModel)=>{
          let model;
          let meshMaterial;

          if (!loadedModel.isMesh){
            model = loadedModel.children[0];
          } else {
            model = loadedModel;
          }

          if (modelObject.material){

            if (modelObject.material.specularMap){
              meshMaterial = new MeshPhongMaterial();
            } else {
              meshMaterial = new MeshStandardMaterial();
            }

            const materials = modelObject.material;

            for (let key in materials) {

              const value = materials[key];

              if ( value instanceof Object){
                let texture;

                const fullUrl = textureUrl + value.path;

                if (globalTextures.hasOwnProperty(fullUrl)){
                  texture = globalTextures[fullUrl];
                } else {
                  texture = textureLoader.load(fullUrl);
                  globalTextures[fullUrl] = texture;
                }

                texture.name = key;

                if (key==='envMap'){
                  texture.mapping = EquirectangularReflectionMapping;
                }

                Object.entries(value).forEach(([key,value])=>{
                  if (key !== 'path'){
                    texture[key]  = value;
                    texture.encoding = LinearEncoding;
                    texture.wrapS = RepeatWrapping;
                    texture.wrapT = RepeatWrapping;
                    texture.offset.set(0,0);
                    texture.repeat.set(1,1);
                  }
                });

                meshMaterial[key] = texture;
              }else{
                meshMaterial[key] = value;
              }

            }

            model.material = meshMaterial;
            model.position.set(0,0,0);
            model.rotation.set(0,0,0);
            model.scale.set(1,1,1);
            model.castShadow = true;
            model.receiveShadow = true;


          } else {
            meshMaterial = model.material.map;

            model.castShadow = false;
            meshMaterial.encoding = LinearEncoding;
            meshMaterial.wrapS = RepeatWrapping;
            meshMaterial.wrapT = RepeatWrapping;
            meshMaterial.offset.set(0,0);
            meshMaterial.repeat.set(1,1);

            meshMaterial.anisotropy = 2;
            meshMaterial.magFilter = LinearFilter;
            meshMaterial.minFilter = LinearMipmapLinearFilter;

            model.material = basic_tile.clone();
            model.material.uniforms.map.value = meshMaterial;
          }

          loadedModel.position.set(modelObject.position.x,modelObject.position.y,modelObject.position.z);
          loadedModel.rotation.set(modelObject.rotation.x,modelObject.rotation.y,modelObject.rotation.z);
          loadedModel.scale.set(modelObject.scale.x,modelObject.scale.y,modelObject.scale.z);
          loadedModel.name = modelObject.name;

          sceneObjectsGroup.add(loadedModel);

        });

        break;

    }

  });

  // threeJsVariables.scene.add(sceneObjectsGroup);


  // const lightMap = loadTexturesForModels();
  // lightMap.then(texture =>{
  //   config.resources.sceneObjects.textures.lightMap = texture;
  //
  //   const models = loadSceneObjectsModels();
  //   models.then(response => {
  //     setModelsAtPoints(response);
  //     startGeneratePoints(response);
  //   });
  // });

}


export function hideSceneObjects(){
  if (!config.resources.sceneObjects.active) return;

  const sceneObjects = threeJsVariables.scene.getObjectByName('Scene objects');

  const tl = gsap.timeline({ onComplete: () => {
      sceneObjects.visible = false;
    }
  });

  sceneObjects.traverse(obj =>{
    if (obj.isMesh){
      tl.to(obj.material,{
        duration: .2,
        transparent: true,
        opacity: 0
      });
    }
  });
}


export function showSceneObjects(){
  if (!config.resources.sceneObjects.active) return;

  const sceneObjects = threeJsVariables.scene.getObjectByName('Scene objects');

  const tl = gsap.timeline({ onStart: () => {
      sceneObjects.visible = true;
    }
  });

  sceneObjects.traverse(obj =>{
    if (obj.isMesh){
      tl.to(obj.material,{
        duration: .2,
        transparent: true,
        opacity: 1,
        onComplete: () => {
          const sceneObject = config.resources.sceneObjects.models.find(model => model.name === obj.parent.name);

          if (sceneObject.material.hasOwnProperty('transparent')) {
            obj.material.transparent = sceneObject.material.transparent;
          } else {
            obj.material.transparent = false;
          }

        }
      });
    }
  });
}




async function startGeneratePoints (models) {
  const isEnabled = settingsData.calculatePoints;
  if (!isEnabled){
    return;
  }

  console.log('%c Points calculating has been started....','color: #32a852');

  const loader = new FBXLoader();
  const baseAreas = config.resources.sceneObjects.baseAreas;
  const {cdnRepository,projectFolder} = config;
  const url = `${cdnRepository}/${projectFolder}/resources/sceneObjects/models/`;

  for (const model of baseAreas) {
    const baseArea = await lazyLoadingData(loader, url + model.path);
    baseArea.position.set(model.position.x,model.position.y,model.position.z);
    baseArea.rotation.set(model.rotation.x,model.rotation.y,model.rotation.z);
    baseArea.scale.set(model.scale.x,model.scale.y,model.scale.z);
    const usedModels = getUsedModels(models, model.models);
    startConstruct(usedModels,baseArea, model);
  }

}

async function setModelsAtPoints (models) {
  const sceneMapping = config.resources.sceneObjects.sceneMapping;
  const isActive = config.resources.sceneObjects.active;
  const isConstructEnabled = settingsData.calculatePoints;
  if (!isActive || isConstructEnabled){
    return;
  }
  const {cdnRepository,projectFolder} = config;
  const platePointsUrl = `${cdnRepository}/${projectFolder}/resources/sceneObjects/platePoints.json`;
  const plateResponse = await axios.get(platePointsUrl);
  platePoints = plateResponse.data;

  sceneMapping.forEach(object =>{
    const points = platePoints[object.key];
    const usedModels = getUsedModels(models, object.models);
    addModelsOnPoints(usedModels,points,object.name,object.position);
  });
}

function getUsedModels (allModels, usedModelsArray) {
  const usedModels = [];

  allModels.forEach(model =>{
    if (usedModelsArray.includes(model.name)){
      usedModels.push(model);
    }
  });

  return usedModels;
}

async function loadSceneObjectsModels () {
  const models = [];
  const modelsArray = config.resources.sceneObjects.models;
  const loader = new FBXLoader();
  const {cdnRepository,projectFolder} = config;
  const url = `${cdnRepository}/${projectFolder}/resources/sceneObjects/models/`;

  for (const model of modelsArray) {
    const response = await lazyLoadingData(loader, url + model.path);
    const loadedModel = response.children[0];
    setInitialModelState(loadedModel,model);
    models.push(loadedModel);
  }

  return models;
}

function loadTexturesForModels () {
  return new Promise(resolve => {
    if (config.resources.sceneObjects.textures.lightMap){
      const textureLoader = new TextureLoader();
      const {cdnRepository,projectFolder} = config;
      const url = `${cdnRepository}/${projectFolder}/resources/sceneObjects/models/`;
      const lightMapTexture = lazyLoadingData(textureLoader,url + config.resources.sceneObjects.textures.lightMap);
      lightMapTexture.then(texture =>{
        resolve(texture);
      });
    } else {
      resolve(null);
    }
  });
}

export function showPointsModels (name) {
  const models = threeJsVariables.scene.getObjectByName(name);

  if (models){
    models.visible = true;
    models.traverse(mesh => {
      if (mesh.isMesh) {
        const animation = gsap.to(mesh.material, {
          duration: 1,
          transparent: true,
          opacity: 1,
          onStart: () => {

          },
          onComplete: () => {

          },
        });
      }
    });
  }
}

export function hidePointsModels (name) {
  const models = threeJsVariables.scene.getObjectByName(name);

  if (models && models.visible){

    models.traverse(mesh => {
      if (mesh.isMesh) {
        const animation = gsap.to(mesh.material, {
          duration: 1,
          transparent: true,
          opacity: 0,
          onStart: () => {

          },
          onComplete: () => {
            models.visible = false;
          },
        });
      }
    });

  }
}


function setInitialModelState (model, modelProperties) {
  model.scale.set(modelProperties.scale.x,modelProperties.scale.y,modelProperties.scale.z);
  model.material.map.encoding = LinearEncoding;
  model.material.transparent = true;
  model.material.alphaTest = 0.5;
  model.material.shininess = 0;
  model.material.specular = new Color(0x000000);
  model.name = modelProperties.name;

  Object.entries(modelProperties.material).forEach(([key,value]) =>{
    switch (key) {
      case 'color':
        model.material[key] = new Color(value);
        break;
      case 'lightMap':
        if (value){
          model.material.lightMap = config.resources.sceneObjects.textures.lightMap;
        }
        break;
      default:
         model.material[key] = value;
        break;
    }
  });
}

export function addModelsOnPoints (models, arrayOfPoints,name, position) {
  const group = new Group();
  group.name = name;
  group.position.set(position.x,position.y,position.z);

  const maxArrayIndex = arrayOfPoints.length - 1;
  const elementsInOneArray = Math.floor(maxArrayIndex / models.length);

  const slicedArrays = sliceArray(arrayOfPoints, elementsInOneArray);

  slicedArrays.forEach((array, index) =>{
    const model = models[index];
    if (model){
      const instance = createInstanceModel(models[index],array,array.length);
      group.add(instance);
    }
  });

  threeJsVariables.scene.add(group);

}


function startConstruct (models, baseArea, modelProperties) {
  const maxSquare = getMaxSquare(models);

  const raycaster = new Raycaster();

  const allPoints = [];

  threeJsVariables.scene.add(baseArea);


  baseArea.children.forEach(childPlate =>{
    const points = calculatePoints(childPlate,modelProperties.squareModification,raycaster,maxSquare);
    allPoints.push(...points);
  });

  shuffleArray(allPoints);

  console.log(`%c Total points at plate-${modelProperties.name}: ${allPoints.length}. The result you can get from localStorage`,'color:' +
      ' #32a852');

  localStorage.setItem(`points-${modelProperties.name}`,JSON.stringify(allPoints));

  const group = new Group();
  group.name = `plate-${modelProperties.name}`;

    const maxArrayIndex = allPoints.length - 1;
    const elementsInOneArray = Math.floor(maxArrayIndex / models.length);

    const slicedArrays = sliceArray(allPoints, elementsInOneArray);

    slicedArrays.forEach((array, index) =>{
      const model = models[index];
      if (model){
        const instanceTrees = createInstanceModel(models[index],array,array.length);
        group.add(instanceTrees);
      }
    });

    threeJsVariables.scene.add(group);

}

function calculatePoints (plate, squareModification,raycaster,maxSquare) {
  const points =[];
  const size = getPlateSize(plate);
  const maxX = size.x / 2;
  const minX = (size.x / 2) * -1;
  const maxZ = size.z / 2;
  const minZ = (size.z / 2) * -1;
  const directionToPlant = maxX > maxZ ? 'x' : 'z';

  let firstMin, firstMax, secondMin, secondMax;

  switch (directionToPlant) {
    case 'x':
      firstMin = minZ;
      firstMax = maxZ;
      secondMin = minX;
      secondMax = maxX;
      break;
    case 'z':
      firstMin = minX;
      firstMax = maxX;
      secondMin = minZ;
      secondMax = maxZ;
      break;
  }

  for (let min = firstMin; min < firstMax; min +=squareModification * maxSquare){
    for (let sMin = secondMin; sMin < secondMax; sMin +=squareModification * maxSquare){

      const rZ = min * Math.random() * 5;
      const rX = sMin * Math.random() * 5;

      const geometry = new BoxBufferGeometry(1,1,1);
      const material = new MeshBasicMaterial({color: 0x000000});
      const cube = new Mesh(geometry,material);
      cube.position.set(rX,rZ,0);
      plate.add(cube);

      const cubeWorldPosition = cube.getWorldPosition(new Vector3());

      const origin = new Vector3().copy(cubeWorldPosition);
      origin.y = 1000;
      const direction = new Vector3().copy(cubeWorldPosition);
      direction.y = -1000;
      raycaster.set(origin, direction.sub(origin).normalize());

      const intersects = raycaster.intersectObjects([plate]);
      if (intersects.length){
        points.push(cubeWorldPosition);
        plate.remove(cube);
      } else {
        plate.remove(cube);
      }

      geometry.dispose();
      material.dispose();

    }

  }

  if (!points.length){
    if (plate.geometry){
      const arrayValue = [0,1,2,3];
      const random = Math.floor(Math.random() * arrayValue.length);
      const vertices = plate.geometry.getAttribute('position');
      const point = new Vector3().fromBufferAttribute(vertices,arrayValue[random]);

      const geometry = new BoxBufferGeometry(1,1,1);
      const material = new MeshBasicMaterial({color: 0x030bfc});
      const cube = new Mesh(geometry,material);
      cube.position.set(point.x,point.y,point.z);
      plate.add(cube);

      const cubeWorldPosition = cube.getWorldPosition(new Vector3());
      points.push(cubeWorldPosition);

      geometry.dispose();
      material.dispose();
      plate.remove(cube);
    }
  }

  return points;

}


function sliceArray (array, pieces) {
  const newArr = [];
  for (let i = 0; i < array.length; i +=pieces){
    newArr.push(array.slice(i,i + pieces));
  }
  return newArr;
}

function randomRotation (min,max) {
  return min + ((max - min) * Math.random());
}

function createInstanceModel (model,arrayOfPoints, count) {
  const instanceMesh = new InstancedMesh(model.geometry,model.material,count);
  instanceMesh.castShadow = false;
  instanceMesh.receiveShadow = false;
  instanceMesh.frustumCulled = false;
  instanceMesh.scale.set(1,1,1);

  let i = 0;

  arrayOfPoints.forEach(point=>{
    const matrix = new Matrix4();
    const rotation = new Euler(0, 2 * Math.PI * Math.random(),randomRotation(0,0.2),'XYZ');
    const quaternion = new Quaternion().setFromEuler(rotation);
    const randomScale = model.scale.x * Math.random() + model.scale.x;
    const scaleVector = new Vector3(randomScale,randomScale,randomScale);
    // const scaleVector = new Vector3(model.scale.x,model.scale.x,model.scale.x);
    const position = new Vector3(point.x,point.y - Math.random() * 5 ,point.z);
    // const scaleVector = new Vector3(model.scale.x, model.scale.y,model.scale.z);
    matrix.compose(position,quaternion,scaleVector);
    instanceMesh.setMatrixAt(i,matrix);
    i++;
  });

  instanceMesh.renderOrder = 1;
  instanceMesh.name = `instanceTree${model.name}`;

  return instanceMesh;
}

function shuffleArray (array) {
  return array.sort(() => Math.random() - 0.5);
}

function getPlateSize (plate) {
  return new Box3().setFromObject(plate).getSize(new Vector3());
}

function getPlateCenter (plate) {
  return new Box3().setFromObject(plate).getCenter(new Vector3());
}

function getPlateSquare (plate) {
  const box = new Box3().setFromObject(plate).getSize(new Vector3());
  return Math.floor(box.x * box.z);
}

function getMaxSquare (treesArray) {
  const squares = [];
  treesArray.forEach(tree=>{
    const box = new Box3().setFromObject(tree).getSize(new Vector3());
    const square = box.x * box.z;
    squares.push(square);
  });

  return Math.ceil(Math.max(...squares));
}
